<template>
    <div>
        <Loading :active="loading" :is-full-page="true" />
        <div align="center" justify="center" class="pa-3">
            <v-card align="left" justify="left" class="mb-3">
                <v-card-text class="pa-3 font-weight-light white black--text">
                    <v-icon class="primary--text lighten-2 pa-2">
                        mdi-webhook
                    </v-icon>
                    Relatórios > Monitoramento de Webhooks
                </v-card-text>
            </v-card>

            <v-card class="pa-3 mb-4">
                <v-row class="pa-3 d-flex align-center">
                    <v-col cols="12" md="3">
                        <v-text-field
                            v-model="filtroDataInicio"
                            type="date"
                            label="Data inicial"
                            outlined
                            dense
                            hide-details
                            :disabled="loading"
                            data-cy="filtroDataInicio"
                        />
                    </v-col>
                    <v-col cols="12" md="3">
                        <v-text-field
                            v-model="filtroDataFim"
                            type="date"
                            label="Data final"
                            outlined
                            dense
                            hide-details
                            :disabled="loading"
                            data-cy="filtroDataFim"
                        />
                    </v-col>
                    <v-col cols="12" md="2">
                        <v-select
                            v-model="filtroStatus"
                            :items="statusOptions"
                            item-text="name"
                            item-value="value"
                            label="Status"
                            outlined
                            dense
                            hide-details
                            clearable
                            :disabled="loading"
                            data-cy="filtroStatus"
                        />
                    </v-col>
                    <v-col cols="12" md="2">
                        <v-text-field
                            v-model="filtroIdTitulo"
                            label="ID Título"
                            type="number"
                            outlined
                            dense
                            hide-details
                            :disabled="loading"
                            data-cy="filtroIdTitulo"
                        />
                    </v-col>
                    <v-col cols="12" md="2">
                        <v-text-field
                            v-model="filtroNossoNumero"
                            label="Nosso Número"
                            outlined
                            dense
                            hide-details
                            :disabled="loading"
                            data-cy="filtroNossoNumero"
                        />
                    </v-col>
                </v-row>
                <v-row class="pa-3 d-flex align-center">
                    <v-col cols="12" md="2" v-if="isSuperUser">
                        <v-autocomplete
                            v-model="filtroCdApresentante"
                            :items="apresentantes"
                            :item-text="item => `${item.cd_apresentante} - ${item.nm_apresentante}`"
                            :filter="customFilterApresentante"
                            item-value="cd_apresentante"
                            label="Apresentante (sigla ou nome)"
                            outlined
                            dense
                            hide-details
                            clearable
                            :loading="loading || loadingApresentantes"
                            :disabled="loading"
                            data-cy="filtroCdApresentante"
                        >
                            <template v-slot:item="data">
                                <v-list-item-content>
                                    <v-list-item-title>
                                        {{ data.item.nm_apresentante }}
                                    </v-list-item-title>
                                    <v-list-item-subtitle>
                                        {{ data.item.cd_apresentante }}
                                    </v-list-item-subtitle>
                                </v-list-item-content>
                            </template>
                        </v-autocomplete>
                    </v-col>
                    <v-col class="d-flex justify-end align-center pa-3">
                        <v-btn
                            color="info"
                            class="mr-2"
                            :disabled="loading"
                            @click="aplicarFiltros"
                            data-cy="btnFiltrar"
                        >
                            <v-icon left>mdi-magnify</v-icon>
                            Filtrar
                        </v-btn>
                        <v-btn
                            outlined
                            color="secondary"
                            class="mr-2"
                            :disabled="loading"
                            @click="limparFiltros"
                            data-cy="btnLimpar"
                        >
                            <v-icon left>mdi-filter-remove</v-icon>
                            Limpar
                        </v-btn>
                        <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                    v-if="isSuperUser"
                                    color="warning"
                                    class="mr-2"
                                    :disabled="loading"
                                    v-bind="attrs"
                                    v-on="on"
                                    @click="abrirConfirmacaoDispatcher"
                                    data-cy="btnDispatcher"
                                >
                                    <v-icon left>mdi-play-circle</v-icon>
                                    Rodar Dispatcher
                                </v-btn>
                            </template>
                            <span>Busca webhooks elegíveis e dispara o webhook-handler Lambda</span>
                        </v-tooltip>
                        <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                    v-if="isSuperUser"
                                    color="error"
                                    class="mr-2"
                                    :disabled="loading"
                                    v-bind="attrs"
                                    v-on="on"
                                    @click="abrirConfirmacaoWatchdog"
                                    data-cy="btnWatchdog"
                                >
                                    <v-icon left>mdi-shield-refresh</v-icon>
                                    Rodar Watchdog
                                </v-btn>
                            </template>
                            <span>Reclassifica webhooks presos em "processing" para "pending"</span>
                        </v-tooltip>
                    </v-col>
                </v-row>
            </v-card>

            <v-card class="pa-3">
                <v-toolbar
                    v-if="isSuperUser"
                    flat
                    dense
                    class="mb-2"
                    data-cy="toolbarLote"
                >
                    <v-icon left color="info">mdi-checkbox-multiple-marked</v-icon>
                    <span v-if="selecionarTodosFiltrados" data-cy="textoSelecaoLote">
                        Todos os <b class="mx-1">{{ totalItems }}</b> webhooks filtrados selecionados
                    </span>
                    <span v-else-if="selecionados.length" data-cy="textoSelecaoLote">
                        <b>{{ selecionados.length }}</b>&nbsp;webhook(s) selecionado(s)
                        <span v-if="qtdFailedSelecionados !== selecionados.length" class="ml-1">
                            ({{ qtdFailedSelecionados }} com status failed)
                        </span>
                    </span>
                    <span v-else class="grey--text" data-cy="textoSelecaoLote">
                        Selecione webhooks pelos checkboxes para reprocessar em lote
                    </span>
                    <v-spacer></v-spacer>
                    <v-btn
                        v-if="!selecionarTodosFiltrados && totalItems > 0 && totalItems > selecionados.length"
                        text
                        small
                        color="info"
                        :disabled="loading"
                        @click="ativarSelecaoTodosFiltrados"
                        data-cy="btnSelecionarTodosFiltrados"
                    >
                        Selecionar todos os {{ totalItems }} filtrados
                    </v-btn>
                    <v-btn
                        v-if="selecionarTodosFiltrados || selecionados.length"
                        text
                        small
                        color="grey"
                        :disabled="loading"
                        @click="limparSelecaoLote"
                        data-cy="btnLimparSelecao"
                    >
                        Limpar seleção
                    </v-btn>
                    <v-btn
                        color="info"
                        small
                        :disabled="loading || (!selecionarTodosFiltrados && !selecionados.length)"
                        @click="abrirConfirmacaoLote"
                        data-cy="btnReprocessarLote"
                    >
                        <v-icon left small>mdi-replay</v-icon>
                        Reprocessar em lote{{ selecionarTodosFiltrados ? ` (${totalItems})` : selecionados.length ? ` (${selecionados.length})` : '' }}
                    </v-btn>
                </v-toolbar>
                <v-data-table
                    :headers="headers"
                    :items="webhooks"
                    :loading="loading"
                    :footer-props="{
                        itemsPerPageOptions: [10, 20, 50, 100],
                        itemsPerPageText: 'Itens por página:'
                    }"
                    item-key="id"
                    class="elevation-1"
                    :server-items-length="totalItems"
                    :page.sync="currentPage"
                    :items-per-page.sync="itemsPerPage"
                    :show-select="isSuperUser"
                    v-model="selecionados"
                    @update:page="carregarDados"
                    @update:items-per-page="carregarDados"
                    @click:row="abrirDetalhe"
                    @toggle-select-all="aoAlternarSelecaoPagina"
                >
                    <template v-slot:[`item.status`]="{ item }">
                        <v-chip
                            :color="statusColor(item.status)"
                            small
                            dark
                        >
                            {{ item.status }}
                        </v-chip>
                    </template>

                    <template v-slot:[`header.next_attempt_at`]>
                        <span>
                            Próxima tentativa
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-icon small class="ml-1" v-bind="attrs" v-on="on" color="info">mdi-information</v-icon>
                                </template>
                                <span>Pode levar de 5 a 9 minutos para ser enviado aproximadamente.</span>
                            </v-tooltip>
                        </span>
                    </template>

                    <template v-slot:[`item.next_attempt_at`]="{ item }">
                        <span v-if="item.status !== 'success' && item.attempts < 3">
                            {{ formatarDataHoraUtcMinus3(item.next_attempt_at) }}
                        </span>
                    </template>

                    <template v-slot:[`item.last_attempt_at`]="{ item }">
                        {{ formatarDataHoraUtcMinus3(item.last_attempt_at) }}
                    </template>

                    <template v-slot:[`item.created_at`]="{ item }">
                        {{ formatarDataHoraUtcMinus3(item.created_at) }}
                    </template>

                    <template v-slot:[`item.updated_at`]="{ item }">
                        {{ formatarDataHoraUtcMinus3(item.updated_at) }}
                    </template>

                    <template v-slot:[`item.acoes`]="{ item }">
                        <div class="d-flex align-center">
                            <v-tooltip top>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                        icon
                                        small
                                        color="grey darken-1"
                                        v-bind="attrs"
                                        v-on="on"
                                        @click.stop="abrirDetalhe(item)"
                                        data-cy="btnVerDetalhe"
                                    >
                                        <v-icon small>mdi-eye</v-icon>
                                    </v-btn>
                                </template>
                                <span>Ver detalhes do webhook</span>
                            </v-tooltip>
                            <v-tooltip v-if="isSuperUser" top>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                        icon
                                        small
                                        color="info"
                                        class="ml-1"
                                        v-bind="attrs"
                                        v-on="on"
                                        @click.stop="abrirConfirmacaoReprocessar(item)"
                                        data-cy="btnReprocessar"
                                    >
                                        <v-icon small>mdi-replay</v-icon>
                                    </v-btn>
                                </template>
                                <span>Reprocessar webhook (zera tentativas e volta para pending)</span>
                            </v-tooltip>
                        </div>
                    </template>
                </v-data-table>
            </v-card>
        </div>

        <v-dialog v-model="dialogDetalhe" max-width="900" scrollable>
            <v-card v-if="webhookDetalhe">
                <v-card-title class="headline">
                    Webhook #{{ webhookDetalhe.id }}
                    <v-spacer></v-spacer>
                    <v-chip
                        :color="statusColor(webhookDetalhe.status)"
                        dark
                        small
                    >
                        {{ webhookDetalhe.status }}
                    </v-chip>
                </v-card-title>
                <v-card-text>
                    <v-row>
                        <v-col cols="12" md="6">
                            <div><b>Apresentante:</b> {{ webhookDetalhe.cd_apresentante }} (id {{ webhookDetalhe.apresentante_id }})</div>
                            <div><b>Tipo:</b> {{ webhookDetalhe.type }}</div>
                            <div><b>ID Título:</b> {{ webhookDetalhe.id_titulo || '-' }}</div>
                            <div><b>Tentativas:</b> {{ webhookDetalhe.attempts }}</div>
                            <div><b>Último status code:</b> {{ webhookDetalhe.last_status_code || '-' }}</div>
                        </v-col>
                        <v-col cols="12" md="6">
                            <div><b>Criado em:</b> {{ formatarDataHoraUtcMinus3(webhookDetalhe.created_at) }}</div>
                            <div><b>Atualizado em:</b> {{ formatarDataHoraUtcMinus3(webhookDetalhe.updated_at) }}</div>
                            <div v-if="webhookDetalhe.status !== 'success' && webhookDetalhe.attempts < 3"><b>Próxima tentativa:</b> {{ formatarDataHoraUtcMinus3(webhookDetalhe.next_attempt_at) }}</div>
                            <div><b>Última tentativa:</b> {{ formatarDataHoraUtcMinus3(webhookDetalhe.last_attempt_at) }}</div>
                        </v-col>
                    </v-row>

                    <v-alert
                        v-if="webhookDetalhe.last_message && ['skipped', 'failed'].includes(webhookDetalhe.status)"
                        :type="webhookDetalhe.status === 'skipped' ? 'warning' : 'error'"
                        dense
                        outlined
                        class="mt-3"
                    >
                        <b>Motivo:</b> {{ webhookDetalhe.last_message }}
                    </v-alert>

                    <v-divider class="my-3"></v-divider>

                    <div class="subtitle-1 mb-2">Payload</div>
                    <pre class="payload-pre">{{ JSON.stringify(webhookDetalhe.payload, null, 2) }}</pre>

                    <v-divider class="my-3"></v-divider>

                    <div class="subtitle-1 mb-2">Histórico de tentativas ({{ tentativas.length }})</div>
                    <v-data-table
                        v-if="tentativas.length"
                        :headers="headersTentativas"
                        :items="tentativas"
                        :items-per-page="10"
                        sort-by="started_at"
                        :sort-desc="true"
                        class="elevation-1"
                    >
                        <template v-slot:[`item.started_at`]="{ item }">
                            {{ formatarDataHoraUtcMinus3(item.started_at) }}
                        </template>
                        <template v-slot:[`item.finished_at`]="{ item }">
                            {{ formatarDataHoraUtcMinus3(item.finished_at) }}
                        </template>
                        <template v-slot:[`item.status_code`]="{ item }">
                            <v-chip
                                v-if="item.status_code"
                                :color="statusCodeColor(item.status_code)"
                                small
                                dark
                            >
                                {{ item.status_code }}
                            </v-chip>
                            <span v-else>-</span>
                        </template>
                        <template v-slot:[`item.response_body`]="{ item }">
                            <span v-if="item.response_body" class="response-cell" @click="copiarTexto(item.response_body)">{{ item.response_body.substring(0, 80) }}{{ item.response_body.length > 80 ? '...' : '' }}</span>
                            <span v-else>-</span>
                        </template>
                        <template v-slot:[`item.response_headers`]="{ item }">
                            <span v-if="item.response_headers" class="response-cell" @click="copiarTexto(JSON.stringify(item.response_headers, null, 2))">{{ JSON.stringify(item.response_headers).substring(0, 60) }}{{ JSON.stringify(item.response_headers).length > 60 ? '...' : '' }}</span>
                            <span v-else>-</span>
                        </template>
                    </v-data-table>
                    <div v-else class="pa-3 text-center">Nenhuma tentativa registrada.</div>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click="dialogDetalhe = false">Fechar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="dialogConfirmacao" max-width="500">
            <v-card>
                <v-card-title class="headline">{{ confirmacao.titulo }}</v-card-title>
                <v-card-text style="white-space: pre-line;">{{ confirmacao.texto }}</v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="green darken-1" text @click="confirmarAcaoJob">Confirmar</v-btn>
                    <v-btn color="red darken-1" text @click="dialogConfirmacao = false">Cancelar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="dialogLote" max-width="550" data-cy="dialogLote">
            <v-card>
                <v-card-title class="headline">Reprocessar webhooks em lote?</v-card-title>
                <v-card-text>
                    <div v-if="selecionarTodosFiltrados" data-cy="textoConfirmacaoLote">
                        Tem certeza que deseja reprocessar <b>TODOS os {{ totalItems }} webhooks filtrados</b>?
                    </div>
                    <div v-else data-cy="textoConfirmacaoLote">
                        Tem certeza que deseja reprocessar os <b>{{ selecionados.length }} webhook(s) selecionado(s)</b><span v-if="qtdFailedSelecionados !== selecionados.length"> ({{ qtdFailedSelecionados }} com status failed)</span>?
                    </div>
                    <v-alert type="info" dense outlined class="mt-3">
                        Apenas webhooks com status <b>failed</b> serão reprocessados. Os demais serão ignorados pelo servidor.
                    </v-alert>
                    <div class="mt-2 grey--text text--darken-1">
                        Os webhooks serão redefinidos como "pending" com tentativas zeradas e enviados na próxima execução do dispatcher.
                    </div>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="green darken-1" text :loading="loading" @click="confirmarReprocessarLote" data-cy="btnConfirmarLote">Confirmar</v-btn>
                    <v-btn color="red darken-1" text @click="dialogLote = false" data-cy="btnCancelarLote">Cancelar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-snackbar
            v-model="snackbar"
            :color="snackbarColor"
            timeout="5000"
            top
            right
        >
            {{ snackbarMessage }}
            <template v-slot:action="{ attrs }">
                <v-btn text v-bind="attrs" @click="snackbar = false">Fechar</v-btn>
            </template>
        </v-snackbar>
    </div>
</template>

<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import WebhookService from '@/services/WebhookService';
import ApresentanteService from '@/services/apresentanteService';
import moment from 'moment';

export default {
    name: 'MonitoramentoWebhooks',
    components: { Loading },
    data() {
        return {
            loading: false,
            webhooks: [],
            totalItems: 0,
            currentPage: 1,
            itemsPerPage: 20,
            filtroDataInicio: null,
            filtroDataFim: null,
            filtroStatus: null,
            filtroIdTitulo: null,
            filtroNossoNumero: null,
            filtroCdApresentante: null,
            apresentantes: [],
            loadingApresentantes: false,
            statusOptions: [
                { name: 'pending', value: 'pending' },
                { name: 'processing', value: 'processing' },
                { name: 'success', value: 'success' },
                { name: 'failed', value: 'failed' },
            ],
            headers: [
                { text: 'ID', value: 'id', width: 80 },
                { text: 'Apresentante', value: 'cd_apresentante' },
                { text: 'Tipo', value: 'type' },
                { text: 'Status', value: 'status', width: 110 },
                { text: 'Tentativas', value: 'attempts', width: 100 },
                { text: 'Último Status Code', value: 'last_status_code', width: 150 },
                { text: '', value: 'next_attempt_at', width: 180 },
                { text: 'Última tentativa', value: 'last_attempt_at', width: 180 },
                { text: 'Atualizado em', value: 'updated_at', width: 180 },
                { text: 'Ações', value: 'acoes', width: 80, sortable: false },
            ],
            headersTentativas: [
                { text: '#', value: 'attempt_number' },
                { text: 'Iniciado em', value: 'started_at' },
                { text: 'Finalizado em', value: 'finished_at' },
                { text: 'Status', value: 'status_code' },
                { text: 'Duração (ms)', value: 'duration_ms' },
                { text: 'Resposta', value: 'response_body' },
                { text: 'Headers', value: 'response_headers' },
            ],
            snackbar: false,
            snackbarMessage: '',
            snackbarColor: 'info',
            dialogDetalhe: false,
            webhookDetalhe: null,
            tentativas: [],
            dialogConfirmacao: false,
            confirmacao: {
                titulo: '',
                texto: '',
                acao: null,
            },
            webhookReprocessar: null,
            selecionados: [],
            selecionarTodosFiltrados: false,
            dialogLote: false,
        };
    },
    mounted() {
        this.aplicarFiltros();
        if (this.isSuperUser) {
            this.listarApresentantes();
        }
    },
    computed: {
        isSuperUser() {
            return this.$store.getters.getSuperUser === 1;
        },
        qtdFailedSelecionados() {
            return (this.selecionados || []).filter((w) => w && w.status === 'failed').length;
        },
    },
    methods: {
        mostrarMensagem(mensagem, cor = 'info') {
            this.snackbarMessage = mensagem;
            this.snackbarColor = cor;
            this.snackbar = true;
        },
        statusColor(status) {
            switch (status) {
                case 'success': return 'success';
                case 'failed': return 'error';
                case 'processing': return 'info';
                case 'pending': return 'warning';
                default: return 'grey';
            }
        },
        statusCodeColor(code) {
            if (code >= 200 && code < 300) return 'success';
            if (code >= 400 && code < 500) return 'warning';
            if (code >= 500) return 'error';
            return 'grey';
        },
        formatarDataHora(valor) {
            if (!valor) return '-';
            return moment(valor).format('DD/MM/YYYY HH:mm:ss');
        },
        formatarDataHoraUtcMinus3(valor) {
            if (!valor) return '-';
            return moment(valor).format('DD/MM/YYYY HH:mm:ss');
        },
        aplicarFiltros() {
            this.currentPage = 1;
            this.limparSelecaoLote();
            this.carregarDados();
        },
        limparFiltros() {
            this.filtroDataInicio = null;
            this.filtroDataFim = null;
            this.filtroStatus = null;
            this.filtroIdTitulo = null;
            this.filtroNossoNumero = null;
            this.filtroCdApresentante = null;
            this.aplicarFiltros();
        },
        montarFiltros() {
            const filtros = {};
            if (this.filtroDataInicio) filtros.data_inicio = this.filtroDataInicio;
            if (this.filtroDataFim) filtros.data_fim = this.filtroDataFim;
            if (this.filtroStatus) filtros.status = this.filtroStatus;
            if (this.filtroIdTitulo) filtros.id_titulo = this.filtroIdTitulo;
            if (this.filtroNossoNumero) filtros.ds_nosso_numero = this.filtroNossoNumero;
            if (this.filtroCdApresentante) filtros.cd_apresentante = this.filtroCdApresentante;
            return filtros;
        },
        limparSelecaoLote() {
            this.selecionados = [];
            this.selecionarTodosFiltrados = false;
        },
        ativarSelecaoTodosFiltrados() {
            this.selecionarTodosFiltrados = true;
        },
        aoAlternarSelecaoPagina() {
            // O header checkbox do v-data-table seleciona apenas a pagina atual.
            // Para reprocessar tudo (independente da paginacao), o usuario deve
            // usar "Selecionar todos os filtrados". Aqui apenas garantimos que
            // a selecao manual cancela o modo "todos filtrados".
            if (this.selecionarTodosFiltrados) {
                this.selecionarTodosFiltrados = false;
            }
        },
        abrirConfirmacaoLote() {
            if (!this.selecionarTodosFiltrados && !this.selecionados.length) {
                this.mostrarMensagem('Selecione ao menos um webhook para reprocessar em lote', 'warning');
                return;
            }
            this.dialogLote = true;
        },
        async confirmarReprocessarLote() {
            this.dialogLote = false;
            this.loading = true;
            try {
                const service = new WebhookService(this.$http, this.$store);
                let resposta;
                if (this.selecionarTodosFiltrados) {
                    resposta = await service.reprocessarLote({
                        selecionar_todos_filtrados: true,
                        filtros: this.montarFiltros(),
                    });
                } else {
                    const ids = (this.selecionados || []).map((w) => w.id);
                    resposta = await service.reprocessarLote({ webhook_ids: ids });
                }
                const total = resposta?.total_reprocessados ?? 0;
                const ignorados = resposta?.total_ignorados ?? 0;
                this.mostrarMensagem(
                    `${total} webhook(s) reprocessado(s) com sucesso.${ignorados ? ` ${ignorados} ignorado(s) (sem status failed ou apresentante inativo).` : ''}`,
                    'success'
                );
                this.limparSelecaoLote();
                await this.carregarDados();
            } catch (error) {
                console.error('Erro ao reprocessar lote:', error);
                const msg = error?.data?.mensagem || 'Falha ao reprocessar webhooks em lote';
                this.mostrarMensagem(msg, 'error');
            } finally {
                this.loading = false;
            }
        },
        async carregarDados() {
            this.loading = true;
            try {
                const service = new WebhookService(this.$http, this.$store);
                const params = {
                    page: this.currentPage,
                    per_page: this.itemsPerPage,
                    ...this.montarFiltros(),
                };
                const response = await service.listarWebhooks(params);
                this.webhooks = response.results || [];
                this.totalItems = response.total || 0;
                // Mantem selecoes de outras paginas no modo por-ids; apenas garante unicidade.
                if (!this.selecionarTodosFiltrados && this.selecionados.length) {
                    const vistos = new Set();
                    this.selecionados = this.selecionados.filter((w) => {
                        if (!w || vistos.has(w.id)) return false;
                        vistos.add(w.id);
                        return true;
                    });
                }
            } catch (error) {
                console.error('Erro ao listar webhooks:', error);
                this.mostrarMensagem('Erro ao carregar webhooks', 'error');
            } finally {
                this.loading = false;
            }
        },
        customFilterApresentante(item, queryText) {
            const searchText = queryText.toLowerCase();
            const nome = (item.nm_apresentante || '').toLowerCase();
            const sigla = (item.cd_apresentante || '').toLowerCase();
            return nome.includes(searchText) || sigla.includes(searchText);
        },
        async listarApresentantes() {
            this.loadingApresentantes = true;
            try {
                const service = new ApresentanteService(this.$http, this.$store);
                const response = await service.listarApresentantes();
                const arr = [...response.body];
                arr.sort((a, b) => {
                    const nomeA = a.nm_apresentante.toUpperCase();
                    const nomeB = b.nm_apresentante.toUpperCase();
                    return nomeA < nomeB ? -1 : nomeA > nomeB ? 1 : 0;
                });
                this.apresentantes = arr;
            } catch (error) {
                console.error('Erro ao carregar apresentantes:', error);
            } finally {
                this.loadingApresentantes = false;
            }
        },
        async abrirDetalhe(item) {
            this.loading = true;
            try {
                const service = new WebhookService(this.$http, this.$store);
                const response = await service.buscarDetalhes(item.id);
                this.webhookDetalhe = response.webhook;
                this.tentativas = (response.tentativas || []).sort(
                    (a, b) => new Date(b.finished_at) - new Date(a.finished_at)
                );
                this.dialogDetalhe = true;
            } catch (error) {
                console.error('Erro ao buscar detalhe:', error);
                this.mostrarMensagem('Erro ao carregar detalhe do webhook', 'error');
            } finally {
                this.loading = false;
            }
        },
        abrirConfirmacaoDispatcher() {
            this.confirmacao = {
                titulo: 'Rodar dispatcher agora?',
                texto: 'Esta acao vai buscar os webhooks elegiveis e disparar a lambda webhook-handler.',
                acao: 'dispatcher',
            };
            this.dialogConfirmacao = true;
        },
        abrirConfirmacaoWatchdog() {
            this.confirmacao = {
                titulo: 'Rodar watchdog agora?',
                texto: 'Esta acao vai reclassificar webhooks presos em processing por mais de 60 minutos.',
                acao: 'watchdog',
            };
            this.dialogConfirmacao = true;
        },
        abrirConfirmacaoReprocessar(item) {
            this.webhookReprocessar = item;
            this.confirmacao = {
                titulo: 'Reprocessar webhook?',
                texto: `Tem certeza que deseja reprocessar o webhook #${item.id} (Apresentante: ${item.cd_apresentante})?\n\nO webhook será redefinido como "pending" com tentativas zeradas e será enviado na próxima execução do dispatcher.`,
                acao: 'reprocessar',
            };
            this.dialogConfirmacao = true;
        },
        async confirmarAcaoJob() {
            this.dialogConfirmacao = false;
            this.loading = true;
            try {
                const service = new WebhookService(this.$http, this.$store);
                let resposta;
                if (this.confirmacao.acao === 'dispatcher') {
                    resposta = await service.executarDispatcher();
                    this.mostrarMensagem(
                        `Operacao concluida. Elegiveis: ${resposta?.total_elegiveis ?? 0}, Lotes: ${resposta?.total_lotes ?? 0}`,
                        'success'
                    );
                } else if (this.confirmacao.acao === 'watchdog') {
                    resposta = await service.executarWatchdog();
                    this.mostrarMensagem(
                        `Operacao concluida. Reprocessados: ${resposta?.total_reprocessados ?? 0}`,
                        'success'
                    );
                } else if (this.confirmacao.acao === 'reprocessar') {
                    resposta = await service.reprocessarWebhook(this.webhookReprocessar.id);
                    this.mostrarMensagem(
                        `Webhook #${resposta?.webhook_id ?? this.webhookReprocessar.id} reprocessado com sucesso.`,
                        'success'
                    );
                }
                await this.carregarDados();
            } catch (error) {
                console.error('Erro na operacao:', error);
                const msg = error?.data?.mensagem || 'Falha ao executar a operacao';
                this.mostrarMensagem(msg, 'error');
            } finally {
                this.loading = false;
                this.webhookReprocessar = null;
            }
        },
        copiarTexto(texto) {
            if (!texto) return;
            navigator.clipboard.writeText(texto).then(() => {
                this.mostrarMensagem('Copiado para a área de transferência', 'success');
            }).catch(() => {
                this.mostrarMensagem('Erro ao copiar', 'error');
            });
        },
    },
};
</script>

<style scoped>
/deep/ .v-data-table tbody tr {
    cursor: pointer;
}
/deep/ .v-data-table tbody tr:hover {
    background-color: #f5f5f5 !important;
}
.payload-pre {
    background: #f5f5f5;
    padding: 10px;
    border-radius: 4px;
    max-height: 300px;
    overflow: auto;
    font-size: 12px;
}
.response-cell {
    cursor: pointer;
    color: #1565c0;
    text-decoration: underline;
    text-decoration-style: dotted;
}
</style>
